var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Elegibilidade')
}
var staticRenderFns = []

export { render, staticRenderFns }